export class DailyAggregate {
  smpDate: string
  dayName: string
  outdoorTemperature: number
  outdoorTemperatureRounded: number
  outdoorTemperatures: Array<number>
  energyComp: number
  energyAux: number
  energyTot: number
  energyCooling: number
  energyHeating: number
  signatureEnergies: Array<number>
  signatureEnergyTot: number
  temperatureEnergies: Array<object>

  constructor (smpDate:string, dayName:string, outdoorTemperature:number, energyComp:number, energyAux:number, energyTot:number, energyCooling:number, energyHeating:number) {
    this.smpDate = smpDate
    this.dayName = dayName
    this.outdoorTemperature = outdoorTemperature
    this.outdoorTemperatureRounded = Math.round(outdoorTemperature)
    this.energyComp = energyComp
    this.energyAux = energyAux
    this.energyTot = energyTot
    this.energyCooling = energyCooling
    this.energyHeating = energyHeating
    this.signatureEnergyTot = 0
    this.outdoorTemperatures = []
    this.signatureEnergies = []
    this.temperatureEnergies = []
  }

  increaseEnergies (energyComp:number, energyAux:number, energyTot:number, energyCooling:number, energyHeating:number) {
    this.energyComp += energyComp
    this.energyAux += energyAux
    this.energyTot += energyTot
    this.energyCooling += energyCooling
    this.energyHeating += energyHeating
  }

  increaseSignatureEnergyTot (signatureEnergy:number) {
    this.signatureEnergies.push(signatureEnergy)
    const rawEnergy:number = this.signatureEnergies.reduce((a, b) => a + b)
    this.signatureEnergyTot = parseFloat(rawEnergy.toFixed(1))
  }

  addOutdoorTemperature (outdoorTemperature:number) {
    this.outdoorTemperatures.push(outdoorTemperature)
    const rawAverage:number = this.outdoorTemperatures.reduce((a, b) => a + b) / this.outdoorTemperatures.length
    const roundedAverage:string = rawAverage.toFixed(1)
    this.outdoorTemperature = parseFloat(roundedAverage)
    this.outdoorTemperatureRounded = Math.round(outdoorTemperature)
  }

  addTemperatureAndEnergy (paid:string, hour:string, outdoorTemperature:number, signatureEnergy:number, indexHour:number) {
    this.temperatureEnergies.push({
      paid: paid,
      hour: hour,
      outdoorTemperature: outdoorTemperature,
      signatureEnergy: signatureEnergy,
      index: indexHour
    })
  }
}
